import { apiWebhook } from '../../../../http';
class WebhookConfigService {
  async create({ name, event, url_to_send }) {
    return apiWebhook.post('/webhook', {
      name,
      event,
      url_to_send
    });
  }

  async getWithPagination({
    page = 1,
    limit = 10,
    isEnable = true,
    name = ''
  }) {
    return apiWebhook.get(`/webhook`, {
      params: {
        page,
        limit,
        isEnable,
        name
      }
    });
  }

  async update(id, { name, event, url_to_send }) {
    return apiWebhook.put(`/webhook/${id}`, {
      name,
      event,
      url_to_send
    });
  }

  async changeStatus(id) {
    return apiWebhook.put(`/webhook/status/${id}`);
  }
}

export default new WebhookConfigService();
